import { useMemo } from 'react';
import { useRouter } from 'next/router';

const useRouteMatch = () => {
  const router = useRouter();

  return useMemo(
    () => ({
      params: router.query,
      url: router.pathname,
      path: router.pathname,
    }),
    [router],
  );
};

export default useRouteMatch;
